import { render } from "./PlaybookViewDocumentCategory.vue?vue&type=template&id=006a4234&scoped=true"
import script from "./PlaybookViewDocumentCategory.vue?vue&type=script&lang=js"
export * from "./PlaybookViewDocumentCategory.vue?vue&type=script&lang=js"

import "./PlaybookViewDocumentCategory.vue?vue&type=style&index=0&id=006a4234&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006a4234"]])

export default __exports__